// extracted by mini-css-extract-plugin
export default {"container":"EventMessage_container_cEg3x","subject":"EventMessage_subject_cLV3P","showOriginal":"EventMessage_showOriginal_COz1X"};